import { ApiConfig, HttpService, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { MS_PER_MINUTE } from '@skylab-shared/utils';
import { ReportPrintQuery, ReportPrintQueryParameters, ReportPrintResult } from '../queries/report-print.query-base';

export interface SalesByProductsPrintingResult extends ReportPrintResult { }

export interface SalesByProductsPrintingParameters extends ReportPrintQueryParameters { }

export class SalesByProductsPrintingQuery extends ReportPrintQuery<SalesByProductsPrintingResult> {
    public constructor(parameters: SalesByProductsPrintingParameters) {
        super(parameters);
    }
}

export class SalesByProductsPrintingQueryHandlerBase implements QueryHandler<SalesByProductsPrintingQuery, SalesByProductsPrintingResult> {
    private static Url = TaggedUrl.join('salesByProducts/printing', [Tags.Api]);

    public constructor(private readonly http: HttpService) {  }

    public async handleAsync({ parameters }: SalesByProductsPrintingQuery): Promise<SalesByProductsPrintingResult> {
        const requestData = {
            compress: parameters.compress,
            password: parameters.password,
            ecoMode: parameters.ecoMode,
            landscape: parameters.landscape,
            config: {
                parameters: JSON.stringify(parameters.parameters),
                summary: parameters.summary,
                columns: parameters.columns,
                report: 'SprzedazWgProduktow'
            }
        };

        const { data } = await this.http.post<{ url: string; }>(SalesByProductsPrintingQueryHandlerBase.Url, requestData, {timeout: 3 * MS_PER_MINUTE });
        return {
            url: `${ApiConfig.baseUrl}${data.url}`
        };
    }
}
